import { useMutation } from "@tanstack/react-query";
import { GET, POST, PUT, DELETE } from "../../../../services/index";

// รายการตอกบัตรเข้า/ออก ของวันที่เลือก
export const useFetchTimeclockLogs = () => {
  return useMutation({
    mutationFn: async ({ date, userId }) => {
      const params = new URLSearchParams({ date });
      if (userId) params.append("userId", userId);
      return await GET(`/api/v1/timeclock/logs?${params.toString()}`);
    },
  });
};

// เพิ่มรายการตอกบัตรเอง { userId, action, eventTime }
export const useAddTimeclockLog = () => {
  return useMutation({
    mutationFn: async (body) => await POST(`/api/v1/timeclock/logs`, body),
  });
};

// แก้รายการตอกบัตร { id, action, eventTime }
export const useUpdateTimeclockLog = () => {
  return useMutation({
    mutationFn: async ({ id, ...body }) => await PUT(`/api/v1/timeclock/logs/${id}`, body),
  });
};

// ลบรายการตอกบัตร
export const useDeleteTimeclockLog = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/timeclock/logs/${id}`),
  });
};
